import React, {createContext} from 'react';
const AuthContext = createContext(null);
export {AuthContext};